import { PluginKey } from 'prosemirror-state';

// allow upto one space after `@`
export const MENTIONS_OPEN_REGEX = /@(\w+)?\s?(\w+)?$/;

export const MENTIONS_CONTAINER_ID = 'mentions-plugin';
export const MENTIONS_CONTAINER_SELECTOR = `#${MENTIONS_CONTAINER_ID}`;

export const MENTIONS_PLUGIN_KEY = new PluginKey(MENTIONS_CONTAINER_ID);

export const EVENT_KEYS = ['ArrowUp', 'ArrowDown', 'Enter', 'Escape', 'ArrowRight', 'ArrowLeft'];
